import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm1.966-4.059c-1.1.497-2.913.5-4.009-.13-1.563-.914-1.84-2.973-.492-2.973.54 0 .702.367.89.79.165.374.35.792.83 1.04.472.24 1.484.264 2.073-.172.581-.427.528-1.098.212-1.419-.353-.357-.983-.504-1.675-.666-.95-.221-2.02-.47-2.653-1.33-.476-.643-.566-1.78.02-2.603 1.019-1.44 4.01-1.527 5.297-.44 1.188 1.008.867 2.346-.092 2.346-.507 0-.674-.32-.86-.68C9.27 5.248 9 4.73 7.96 4.73c-1.35 0-1.88 1.052-.93 1.564.352.192.854.314 1.396.446 1.442.35 3.174.772 3.174 2.765-.003 1.14-.64 1.992-1.634 2.436Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconSocialSkype16 = createIcon(IconComponent);